/* eslint-disable class-methods-use-this */
/* global axios */
import JwtAuth from './jwtAuth';
import store from '../store';

const url =
  process.env.FRONTEND_ENV === 'develop'
    ? 'https://staging.chatlyn.com/smswamw/wa'
    : window.location.protocol +
      '//' +
      window.location.hostname +
      '/smswamw/wa';

class WhatsAppAPI {
  getPhoenixSendingLimits = async (phoneNumber, accountId) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();
    const baseUrl = url.replace('/smswamw/wa', '');
    const cleanPhone = (phoneNumber || '')
      .toString()
      .replace(/^\+/, '')
      .replace(/\D/g, '');

    return axios.get(
      `${baseUrl}/inboxmw/whatsapp/channels/phonenumber/${cleanPhone}/limit?accountId=${accountId}`,
      {
        headers: {
          Authorization: `Bearer ${jwtAuthTokens.access_token}`,
        },
      }
    );
  };

  uploadMediaFile = async ({ phoneNumber, file, type, filename }) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    const baseUrl = url.replace('/smswamw/wa', '');
    const cleanPhone = (phoneNumber || '').toString().replace(/\D/g, '');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    if (filename) formData.append('filename', filename);

    return axios.post(
      `${baseUrl}/whatsapp/media/upload/file/${cleanPhone}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${jwtAuthTokens.access_token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  };

  getWhatsApp24hSendingLimits = async (phoneNumber) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.post(
      `${url}/getLimit`,
      { number: phoneNumber.replace(/\+/g, '') },
      {
        headers: {
          Authorization: `Bearer ${jwtAuthTokens.access_token}`,
        },
      }
    );
  };

  getWhatsAppWindowExpiration = async ({ accountId, contactId, inboxId }) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    const isPhoenix = store.getters['accounts/isPhoenix'] ?? false;

    const fullUrl = isPhoenix
      ? url.replace('/smswamw/wa', '/inboxmw/conversations/window-expiration')
      : `${url}/windowExpiration`;

    return axios.get(fullUrl, {
      params: { accountId, contactId, inboxId },
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  };

  getWhatsAppCostsWithDetails = async ({ accountId, startDate, endDate }) => {
    const isPhoenix = store.getters['accounts/isPhoenix'] ?? false;

    const jwtAuthTokens = await JwtAuth.getUserTokens();

    const baseUrl = isPhoenix
      ? url.replace('/smswamw/wa', '/inboxmw')
      : url.replace('/wa', '');

    const endpoint = isPhoenix
      ? `/whatsapp/reports/costs/${accountId}`
      : `/chatlyn/accounts/${accountId}/client-costs`;

    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    const fullUrl = `${baseUrl}${endpoint}${
      params.toString() ? `?${params}` : ''
    }`;

    return axios.get(fullUrl, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  };
}

export default new WhatsAppAPI();
